<template>
  <tk-container class="detail" :status="status" @refresh="init">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      水机详情
    </tkui-header>
    <div style="padding-bottom: 20px;">
      <div class="params">
        <tk-flex column center middle class="machineNum">
          <h2 class="number">{{machine.name}}</h2>
          <p class="type">(型号-{{machine.type}})</p>
        </tk-flex>
        <tk-flex average>
          <!--<div class="time" v-if="lease.isStart">-->
            <!--<h2 class="lease" v-if="lease.type === 'isTime'">租赁时间：{{lease.time || '?'}}天</h2>-->
            <!--<h2 class="lease" v-else>租赁水量：{{lease.water || '?'}}L</h2>-->
            <!--<p class="text">租赁机</p>-->
          <!--</div>-->
          <div class="app-supplier">
            <h2 class="lease">{{machine.dealer ? machine.dealer.username : '?'}}</h2>
            <p class="text">供货商</p>
          </div>
        </tk-flex>
        <tk-flex middle class="address">
          <tk-flex center middle class="unshrink addressIcon self-top">
            <span class="icon">地址</span>
          </tk-flex>
          <span class="addressText fill">{{machine.address || '?'}}</span>
        </tk-flex>
        <tk-flex wrap class="items">
          <tk-box class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="num">{{machineStatus.currentTemperature || '?'}}<span class="unit">℃</span></h2>
              <p class="itemName">当前温度</p>
            </tk-flex>
          </tk-box>
          <tk-box class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="data">{{machineStatus.waterLevel || '?'}}</h2>
              <p class="itemName">当前水位</p>
            </tk-flex>
          </tk-box>
          <tk-box class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="data">{{machineStatus.autoRun === undefined ? '?' : Number(machineStatus.autoRun) ? '自动' : '非自动'}}</h2>
              <p class="itemName">运行模式</p>
            </tk-flex>
          </tk-box>
          <tk-box class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="data">{{machineStatus.isStart === undefined ? '?' : Number(machineStatus.isStart) ? '开机' : '关机'}}</h2>
              <p class="itemName">工作状态</p>
            </tk-flex>
          </tk-box>
          <tk-box class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="num">{{machineStatus.waterState}}<span class="unit">ppm</span></h2>
              <p class="itemName">水质状态</p>
            </tk-flex>
          </tk-box>
          <tk-box @click.native="toWarn(machineStatus.runState)" class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="data" :class="{'warn': machineStatus.runState && machineStatus.runState !== '00'}">{{machineStatus.runState && machineStatus.runState === '00' ? '正常' : '告警'}}</h2>
              <p class="itemName">运行状态</p>
            </tk-flex>
          </tk-box>
          <tk-box @click.native="toWater" class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="data1">今日:<span class="num1">{{todayWater}}</span>L</h2>
              <h2 class="data1">月累计:<span class="num1">{{monthWater}}</span>L</h2>
              <p class="itemName">用水量</p>
            </tk-flex>
          </tk-box>
          <tk-box @click.native="toFilters" class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="data" :style="{'color': state.color}">{{state.text}}</h2>
              <p class="itemName">滤芯状态</p>
            </tk-flex>
          </tk-box>
          <tk-box @click.native="toElectric" class="tk-grid-4" ratio="1:1">
            <tk-flex column middle center class="item">
              <h2 class="data1">今日:<span class="num1">{{todayElectric}}</span>度</h2>
              <h2 class="data1">月累计:<span class="num1">{{monthElectric}}</span>度</h2>
              <p class="itemName">用电量</p>
            </tk-flex>
          </tk-box>
        </tk-flex>
      </div>
      <tk-flex average class="btns">
        <tk-flex @click.native="toSet" column center>
          <tk-flex center middle class="app-btn" style="background: #0091ff;">
            <tk-icon size="36">shezhi</tk-icon>
          </tk-flex>
          <!--<tkui-button class="icon raised big primary">-->
            <!--<tk-icon>shezhi</tk-icon>-->
          <!--</tkui-button>-->
          <p class="btnName">远程设置</p>
        </tk-flex>
        <tk-flex @click.native="toRepair" column center>
          <tk-flex center middle class="app-btn" style="background: #fac101;">
            <tk-icon size="36">yijiantousu</tk-icon>
          </tk-flex>
          <!--<tkui-button class="icon raised big accent">-->
            <!--<tk-icon>yijiantousu</tk-icon>-->
          <!--</tkui-button>-->
          <p class="btnName">一键报修</p>
        </tk-flex>
        <tk-flex @click.native="toMaintain" column center>
          <tk-flex center middle class="app-btn" style="background: #54da5d;">
            <tk-icon size="36">weixiu-copy</tk-icon>
          </tk-flex>
          <!--<tkui-button class="icon raised big danger">-->
            <!--<tk-icon>weixiu-copy</tk-icon>-->
          <!--</tkui-button>-->
          <p class="btnName">维修维护</p>
        </tk-flex>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  import moment from 'moment'
  export default {
    data () {
      return {
        status: false,
        machineStatus: {},
        record: [],
        date: new Date(),
        filterStatus: {},
        delay: 5000,
        timeId: 0
      }
    },
    computed: {
      state () {
        if (JSON.stringify(this.filterStatus) === '{}') {
          return {
            color: '#F4E00D',
            text: '暂无数据'
          }
        } else {
          let filters = this.filterStatus
          let isRemaining = false
          let state = {
            color: '#0091FF',
            text: '正常'
          }
          for (let key in filters) {
            let bool = filters[key] && filters[key].start && filters[key].totalTime && filters[key].remaining
            isRemaining = bool
            if (bool && filters[key].remaining <= 5) {
              state = {
                color: '#F41728',
                text: '需更换'
              }
              return state
            }
            if (bool && filters[key].remaining <= 15 && filters[key].remaining > 5) {
              state = {
                color: '#F4E00D',
                text: '需更换'
              }
            }
          }
          return isRemaining ? state : {color: '#F4E00D', text: '暂无数据'}
        }
      },
      machine () {
        return this.$store.state.machine || {}
      },
      monthWater () {
        let num = 0
        if (this.record.length > 0) {
          this.record.forEach(record => {
            num += record.water
          })
        }
        return num.toFixed(1)
      },
      todayWater () {
        let day = moment().date()
        let water = 0
        let recordLength = this.record.length
        if (recordLength > 0) {
          for (let i = 0; i < recordLength; i++) {
            let date = moment(this.record[i].date).date()
            if (date === day) {
              water = this.record[i].water
              break
            }
          }
        }
        return water.toFixed(1)
      },
      monthElectric () {
        let num = 0
        if (this.record.length > 0) {
          this.record.forEach(record => {
            num += record.electric
          })
        }
        return num.toFixed(1)
      },
      todayElectric () {
        let day = moment().date()
        let electric = 0
        let recordLength = this.record.length
        if (recordLength > 0) {
          for (let i = 0; i < recordLength; i++) {
            let date = moment(this.record[i].date).date()
            if (date === day) {
              electric = this.record[i].electric
              break
            }
          }
        }
        return electric.toFixed(1)
      }
    },
    activated () {
      this.init()
      this.getRecord()
      this.getFilter()
    },
    methods: {
      async getFilter () {
        try {
          let rs = await this.$tkParse.getList(`/classes/filter`, {
            params: {
              where: {
                machine: this.machine.objectId
              }
            }
          })
          if (rs[0]) this.filterStatus = rs[0]
        } catch (e) {}
      },
      init () {
        this.initStatus()
        this.refreshStatus()
      },
      refreshStatus () {
        this.timeId = setTimeout(async () => {
          clearTimeout(this.timeId)
          await this.initStatus()
          this.refreshStatus()
        }, this.delay)
      },
      async initStatus () {
        try {
          let status = await this.$tkParse.getList('/classes/status', {
            'params': {
              'where': {
                'machine': this.machine.objectId
              }
            }
          })
          if (status[0]) {
            this.machineStatus = status[0]
            this.$store.commit('setStatus', status[0])
            this.status = false
          } else {
            this.status = 'empty'
          }
        } catch (e) {
          this.status = 'error'
        }
      },
      async getRecord () {
        let start = moment().startOf('month').toISOString()
        let end = moment().endOf('month').toISOString()
        let id = this.machine.objectId
        if (id) {
          try {
            let res = await this.$tkParse.getList('/classes/elecWaterRecord', {
              'params': {
                'where': {
                  'machine': id,
                  'date': {
                    '$gte': {
                      '__type': 'Date',
                      'iso': start
                    },
                    '$lte': {
                      '__type': 'Date',
                      'iso': end
                    }
                  }
                },
                'order': 'date'
              }
            })
            this.record = [...res]
          } catch (e) {
            this.$tkGlobal.toast.add('获取记录失败')
          }
        }
      },
      back () {
        clearTimeout(this.timeId)
        this.$back()
      },
      toWarn (warnings) {
        this.$setFlash('warn', {
          items: warnings
        })
        clearTimeout(this.timeId)
        this.$push('/warn')
      },
      toWater () {
        clearTimeout(this.timeId)
        this.$push('/water')
      },
      toFilters () {
        if (this.state.text === '暂无数据') {
          this.$tkGlobal.toast.add('没有滤芯数据')
          return
        }
        clearTimeout(this.timeId)
        this.$push('/filter')
      },
      toElectric () {
        clearTimeout(this.timeId)
        this.$push('/electric')
      },
      toSet () {
        clearTimeout(this.timeId)
        this.$push('/remote')
      },
      toRepair () {
        clearTimeout(this.timeId)
        this.$push('/repair')
      },
      toMaintain () {
        clearTimeout(this.timeId)
        this.$push('/maintain')
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .detail{
    .params{
      background: #ffffff;
      margin-bottom: 10px;
      .machineNum{
        width: 100%;
        padding: 10px 0;
        margin-bottom: 15px;
        .number{
          font-size: 20px;
          color: #333333;
        }
        .type{
          font-size: 12px;
          color: #999999;
          margin-bottom: 0!important;
        }
      }
      .time,.app-supplier{
        text-align: center;
        margin-bottom: 15px;
      }
      .time{
        border-right: 1px solid #B0D3D2;
      }
      .lease{
        font-size: 16px;
        color: #0091FF;
      }
      .text{
        font-size: 12px;
        color: #666666;
        margin-bottom: 0!important;
      }
      .address{
        width: 100%;
        padding-right: 15px;
        box-sizing: border-box;
        margin-bottom: 15px;
        .addressIcon{
          width: 70px;
          .icon{
            width: 40px;
            height: 23px;
            line-height: 25px;
            text-align: center;
            font-size: 12px;
            color: #ffffff;
            background: #4CB2FF;
            border-radius: 4px;
          }
        }
        .addressText{
          font-size: 12px;
          color: #666666;
          line-height: 20px;
        }
      }
      .items{
        width: 100%;
        box-sizing: border-box;
        border-top: 1px solid #E0E0E0;
        border-left: 1px solid #E0E0E0;
        .item{
          width: 100%;
          height: 100%;
          border-right: 1px solid #E0E0E0;
          border-bottom: 1px solid #E0E0E0;
          box-sizing: border-box;
          .data{
            font-size: 16px;
            color: #0091FF;
          }
          .data1{
            font-size: 12px;
            color: #0091FF;
          }
          .warn{
            color: #E60808;
          }
          .change{
            color: #FAC101;
          }
          .num{
            font-size: 26px;
            color: #0091FF;
          }
          .num1{
            font-size: 14px;
            color: #0091FF;
          }
          .unit{
            font-size: 14px;
          }
          .itemName{
            font-size: 12px;
            color: #999999;
            margin-top: 10px;
            letter-spacing: 1px;
          }
        }
      }
    }
    .btns{
      background: #ffffff;
      padding: 15px 0;
      .app-btn{
        color: #ffffff;
        width: 65px;
        height: 65px;
        border-radius: 50%;
        margin-bottom: 5px;
      }
      .btnName{
        font-size: 14px;
        color: #666666;
        margin-bottom: 0!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/machine/detail.vue